export default __webpack_public_path__ + "static/media/ArticleMobile.c448b7e8.png";